import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import type {
  CreateUserData,
  GetUsersParams,
  PerformActionUserParams,
  UpdateUserParams
} from "./services.type.ts"

const BASE_URL = "/user/users"

const PATHS = {
  filterOptions: `${BASE_URL}/filter_options/`,
  users: `${BASE_URL}/`,
  userDetails: (id: string) => `${BASE_URL}/${id}/`,
  userDetailsNew: (id: string) => `${BASE_URL}/${id}/manage/`,
  invite: `${BASE_URL}/invite/`,
  userAction: (id: string, action: string) => `${BASE_URL}/${id}/${action}/`,
  invitation: (inviteId: string) => `${BASE_URL}/invitation/${inviteId}/`
}

export const getUsersFilterOptions = (): Promise<ApiResponse<any>> => {
  return request.api.get(PATHS.filterOptions)
}

export const getUsers = (
  params?: GetUsersParams
): Promise<ApiResponse<any>> => {
  return request.api.get(PATHS.users, params)
}

export const getUserDetails = (leadID: string): Promise<ApiResponse<any>> => {
  return request.api.get(PATHS.userDetails(leadID))
}

export const createUser = (data: CreateUserData): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.invite, data)
}

export const newUpdateUser = ({
  id,
  ...newInfo
}: UpdateUserParams): Promise<ApiResponse<any>> => {
  return request.api.patch(PATHS.userDetailsNew(id), newInfo)
}

export const deleteUser = (leadID: string): Promise<ApiResponse<any>> => {
  return request.api.delete(PATHS.userDetails(leadID))
}

// const allowedActions = ['block', 'unblock', 'resend_invite']
export const performActionUser = ({
  action,
  id,
  ...data
}: PerformActionUserParams): Promise<ApiResponse<any>> => {
  return request.api.post(PATHS.userAction(id, action), data)
}

export const getInviteUserInfo = (
  inviteId: string
): Promise<ApiResponse<any>> => {
  return request.api.get(PATHS.invitation(inviteId))
}
